<template>
  <section class="adjudication-progress">
    <div class="adjudication-progress__top">
      <article class="adjudication-progress__notice">
        <img :src="handsIcon" alt="" class="adjudication-progress__notice-icon" aria-hidden="true" />

        <div class="adjudication-progress__notice-copy">
          <DsText as="bebas3" color="var(--ds-purple-900)" class="adjudication-progress__notice-title">
            &iquest;Cu&aacute;ndo ocurre tu adjudicaci&oacute;n?
          </DsText>

          <DsText as="body4" class="adjudication-progress__notice-text">
            Los contratos adjudicados se determinan el
            <strong>tercer viernes h&aacute;bil de cada mes.</strong>
          </DsText>
        </div>

        <div class="adjudication-progress__channels">
          <DsText as="subtitle8" color="var(--ds-purple-900)" class="adjudication-progress__channels-label">
            Te Notificamos por
          </DsText>

          <ul class="adjudication-progress__channel-list">
            <li v-for="channel in notificationChannels" :key="channel.label" class="adjudication-progress__channel">
              <img :src="channel.icon" alt="" class="adjudication-progress__channel-icon" aria-hidden="true" />
              <DsText as="body4" class="adjudication-progress__channel-text">{{ channel.label }}</DsText>
            </li>
          </ul>
        </div>
      </article>

      <div class="adjudication-progress__image-wrap">
        <picture>
          <source media="(max-width: 767px)" :srcset="progressImageMobile" />
          <source media="(max-width: 1023px)" :srcset="progressImageTablet" />
          <img :src="progressImageDesktop" alt="Pareja conversando sobre su nuevo hogar" class="adjudication-progress__image" />
        </picture>
      </div>
    </div>

    <div class="adjudication-progress__summary">
      <article class="adjudication-progress__card adjudication-progress__advance">
        <div class="adjudication-progress__advance-header">
          <img :src="starIcon" alt="" class="adjudication-progress__card-icon" aria-hidden="true" />
          <DsText as="bebas3" color="var(--ds-purple-900)" class="adjudication-progress__card-title">
            Tu avance
          </DsText>
        </div>

        <DsText as="body4" class="adjudication-progress__advance-label">
          Porcentaje de cuotas pagadas
        </DsText>

        <DsProgressGauge class="adjudication-progress__chart" />
      </article>

      <article class="adjudication-progress__card adjudication-progress__status">
        <DsText as="body4" class="adjudication-progress__status-label">
          Tipo de adjudicaci&oacute;n m&aacute;s cercana
        </DsText>
        <span class="adjudication-progress__pill adjudication-progress__pill--purple">
          <span class="adjudication-progress__dot" />
          Natural
        </span>

        <DsText as="body4" class="adjudication-progress__status-label">
          Estatus actual
        </DsText>
        <span class="adjudication-progress__pill adjudication-progress__pill--green">
          <span class="adjudication-progress__dot" />
          En proceso
        </span>
      </article>
    </div>

    <article class="adjudication-progress__card adjudication-progress__next">
      <img :src="handstarIcon" alt="" class="adjudication-progress__hand_card-icon" aria-hidden="true" />

      <DsText as="bebas3" color="var(--ds-purple-900)" class="adjudication-progress__next-title">
        Lo que sigue para ti
      </DsText>

      <DsText as="body4" class="adjudication-progress__next-text">
        Completa el pago del complemento de inscripci&oacute;n dentro de los 5 d&iacute;as h&aacute;biles posteriores
        a la notificaci&oacute;n y contin&uacute;a avanzando hacia tu patrimonio sin contratiempos.
      </DsText>
    </article>
  </section>
</template>

<script setup lang="ts">
import DsText from '../atoms/DsText.vue'
import DsProgressGauge from '../components/DsProgressGauge.vue'

const bookIcon = new URL('../../../../../assets/adjudicacion/adjudicaciones_book.svg', import.meta.url).href
const handsIcon = new URL('../../../../../assets/adjudicacion/adjudicaciones_hands.svg', import.meta.url).href
const mailIcon = new URL('../../../../../assets/adjudicacion/adjudicaciones_mail.svg', import.meta.url).href
const phoneIcon = new URL('../../../../../assets/adjudicacion/adjudicaciones_phone.svg', import.meta.url).href
const starIcon = new URL('../../../../../assets/adjudicacion/adjudicaciones_star.svg', import.meta.url).href
const progressImageDesktop = new URL('../../../../../assets/adjudicacion/adjudicaciones2_desktop.png', import.meta.url).href
const progressImageMobile = new URL('../../../../../assets/adjudicacion/adjudicaciones2_mobile.png', import.meta.url).href
const progressImageTablet = new URL('../../../../../assets/adjudicacion/adjudicaciones2_tablet.png', import.meta.url).href
const handstarIcon = new URL('../../../../../assets/adjudicacion/adjudicaciones_handstar.svg', import.meta.url).href

const notificationChannels = [
  { icon: mailIcon, label: 'Correo electr\u00f3nico' },
  { icon: phoneIcon, label: 'Llamada' },
  { icon: bookIcon, label: 'Publicaci\u00f3n oficial' }
]
</script>

<style scoped>
/* 962px: mismo ancho de contenido que el hero y "Formas de adjudicación". */
.adjudication-progress {
  width: 100%;
  max-width: 962px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.adjudication-progress__top,
.adjudication-progress__summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.adjudication-progress__notice,
.adjudication-progress__card {
  background: var(--ds-grey-50);
  border-radius: 24px;
  box-sizing: border-box;
}

.adjudication-progress__notice {
  min-height: 384px;
  padding: 28px 28px 26px;
  border: 1px solid var(--ds-grey-300);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 28px;
}

.adjudication-progress__notice-icon {
  width: 56px;
  height: auto;
}

.adjudication-progress__notice-copy {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.adjudication-progress__notice-title {
  font-size: var(--ds-h4-size);
}

.adjudication-progress__notice-text {
  font-size: var(--ds-body3-size);
}

.adjudication-progress__notice-text strong {
  font-weight: 600;
}

.adjudication-progress__channels {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.adjudication-progress__channels-label {
  font-size: var(--ds-body3-size);
}

.adjudication-progress__channel-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.adjudication-progress__channel {
  display: flex;
  align-items: center;
  gap: 12px;
}

.adjudication-progress__channel-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.adjudication-progress__channel-text {
  color: var(--ds-text-primary);
  font-size: var(--ds-body3-size);
}

.adjudication-progress__image-wrap {
  overflow: hidden;
  min-height: 384px;
  border-radius: 24px;
}

.adjudication-progress__image-wrap picture {
  display: block;
  width: 100%;
  height: 100%;
}

.adjudication-progress__image {
  width: 100%;
  height: 100%;
  min-height: 384px;
  display: block;
  object-fit: cover;
  object-position: center;
}

.adjudication-progress__card {
  padding: 28px;
}

.adjudication-progress__advance {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.adjudication-progress__advance-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.adjudication-progress__card-icon {
  width: 53px;
  height: 56px;
  object-fit: contain;
}

.adjudication-progress__hand_card-icon {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.adjudication-progress__card-title {
  font-size: var(--ds-h4-size);
}

.adjudication-progress__advance-label {
  color: var(--ds-text-primary);
  text-align: center;
  font-size: var(--ds-body3-size);
}

.adjudication-progress__chart {
  display: block;
  height: 110px;
}

.adjudication-progress__status {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
}

.adjudication-progress__status-label {
  color: var(--ds-text-primary);
  text-align: center;
  font-size: var(--ds-body3-size);
}

/* Figma: el chip se ajusta a su contenido (padding 8px/24px), no al ancho. */
.adjudication-progress__pill {
  align-self: center;
  height: 33px;
  padding: 0 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-body4-size);
  font-weight: 600;
  line-height: 20px;
  box-sizing: border-box;
}

.adjudication-progress__pill--purple {
  background: var(--ds-purple-50);
  color: var(--ds-purple-main);
}

.adjudication-progress__pill--green {
  background: var(--ds-success-100);
  color: var(--ds-success-900);
}

.adjudication-progress__dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: currentColor;
}

.adjudication-progress__next {
  min-height: 196px;
  padding: 32px 28px 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
}

.adjudication-progress__next-title {
  font-size: var(--ds-h4-size);
}

.adjudication-progress__next-text {
  color: var(--ds-text-primary);
  font-size: var(--ds-body3-size);
}

@media (max-width: 767px) {
  .adjudication-progress {
    max-width: 100%;
    gap: 18px;
  }

  .adjudication-progress__top,
  .adjudication-progress__summary {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .adjudication-progress__notice {
    min-height: 192px;
    padding: 20px 18px;
    border: 0;
    gap: 18px;
  }

  .adjudication-progress__notice-icon {
    width: 40px;
  }

  .adjudication-progress__channels {
    gap: 14px;
  }

  .adjudication-progress__channel-list {
    gap: 10px;
  }

  .adjudication-progress__channel-icon {
    width: 14px;
    height: 14px;
  }

  .adjudication-progress__image-wrap,
  .adjudication-progress__image {
    min-height: 210px;
  }

  .adjudication-progress__card {
    border-radius: 18px;
  }

  .adjudication-progress__advance,
  .adjudication-progress__status {
    min-height: 220px;
    padding: 18px;
  }

  .adjudication-progress__advance {
    gap: 16px;
  }

  .adjudication-progress__advance-header {
    gap: 10px;
  }

  .adjudication-progress__card-icon {
    width: 56px;
  }

  .adjudication-progress__chart {
    --ds-progress-gauge-stroke-width: 14;
    --ds-progress-gauge-percentage-size: 28px;
    --ds-progress-gauge-percentage-bottom: 8px;

    width: 220px;
    height: 110px;
  }

  .adjudication-progress__status {
    gap: 14px;
  }

  .adjudication-progress__next {
    min-height: 152px;
    padding: 22px 18px;
    gap: 12px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .adjudication-progress {
    gap: 24px;
  }

  .adjudication-progress__top,
  .adjudication-progress__summary {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .adjudication-progress__notice {
    min-height: 292px;
    padding: 28px 24px;
    border: 0;
    gap: 22px;
  }

  .adjudication-progress__image-wrap,
  .adjudication-progress__image {
    min-height: 264px;
  }

  .adjudication-progress__advance,
  .adjudication-progress__status {
    min-height: 148px;
  }

  .adjudication-progress__next {
    min-height: 168px;
  }
}
</style>

